<template>
    <div>
        <veui-dialog
            :open="isShow"
            :footless="true"
            ui="auto"
            overlay-class="add-dialog"
            @cancel="cancel"
        >
            <!-- 消息轮播 -->
            <veui-carousel
                class="banner-box"
                indicator-align="end"
                indicator-position="outside"
                controls-position="outside"
                :autoplay="list.length > 1"
                :interval="4000"
                :controls="true"
                effect="slide"
                :wrap="list.length > 1"
                :indicator="list.length > 1 ? 'radio' : 'none'"
                :datasource="list"
                :index.sync="index"
            >
                <div
                    slot="item"
                    slot-scope="{title, content, notice_time, pic, button_text, button_url, negotiates, id}"
                    class="main-content-box"
                >
                    <div class="title">{{ title }}</div>
                    <div
                        v-if="notice_time"
                        class="time"
                    >
                        {{ notice_time * 1000 | dateFormat }}
                    </div>
                    <div
                        class="img-box"
                        :style="{backgroundImage: `url(${pic})`}"
                    >
                        <div v-if="qrcodeUrl && id === 59" class="qrcode-box">
                            <img :src="qrcodeUrl">
                            <div class="qrcode-title">法行宝律师服务号</div>
                        </div>
                    </div>
                    <div
                        v-if="content"
                        class="description"
                    >
                        <span>
                            {{ content }}<template v-if="negotiates && negotiates.length">
                                <span
                                    v-for="(itemNe, indexNe) in negotiates"
                                    :key="indexNe"
                                    class="agreement"
                                    @click="toAgreement(itemNe.negotiate_url)"
                                >《{{ itemNe.negotiate_title }}》</span>
                            </template>
                        </span>
                    </div>
                    <veui-button
                        v-if="button_text && button_url"
                        ui="primary l"
                        class="btn"
                        @click="goPage(button_url)"
                    >
                        {{ button_text }}
                    </veui-button>
                </div>
            </veui-carousel>
        </veui-dialog>
    </div>
</template>
<script>
/**
 * @file 法律 新版本发布弹框
 */

import {mapState} from 'vuex';
import {Dialog, Button, Carousel} from 'veui';
import {dateFormat} from '../../utils/util';

export default {
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button,
        'veui-carousel': Carousel
    },
    props: {
        // 列表
        list: {
            'type': Array,
            'default': []
        }
    },
    filters: {
        dateFormat
    },
    data() {
        return {
            index: 0,
            isShow: true
        };
    },
    computed: {
        ...mapState({
            qrcodeUrl: state => state.lawStore.qrcodeUrl
        })
    },
    watch: {
        // 轮播下标
        index: {
            deep: true,
            immediate: true,
            handler(val) {
                this.$emit('carouselChange', {...this.list[val] || {}, index: val});
            }
        }
    },
    methods: {
        toAgreement(url) {
            window.open(url || 'https://lvlin-lawyer.cdn.bcebos.com/agreement/lawyer_agent_confirm_disrtribution.pdf');
        },
        /**
         * 点击取消
         * @param {点击} area
         */
        cancel(area = 'close-btn') {
            this.$wywLog.send({
                serverId: 16506,
                page: 'lawinfo',
                action: 'click',
                index: this.index,
                activityId: this.list[this.index] && this.list[this.index].id,
                area
            });
            this.isShow = false;
            this.$emit('cancel');
        },
        /**
         * 按钮点击
         * @param {string} link 跳转链接
         */
        goPage(link) {
            this.cancel('bottom-btn');
            if (!link) {
                return;
            }
            if (link.indexOf('https') > -1 || link.indexOf('http') > -1) {
                window.open(link);
                return;
            }
            this.$router.push({
                path: link
            });
        }
    }
};
</script>
<style lang='less' scoped>
    .add-dialog {
        font-family: PingFangSC-Regular;
        line-height: 1;

        /deep/ .veui-dialog-content {
            width: 660px;
            position: relative;
            overflow-y: unset;
            padding-bottom: 0;
        }

        /deep/ .veui-dialog-content-head {
            position: absolute;
            right: 0;
            top: 0;
            z-index: 11;
            padding: 28px 30px;
        }

        /deep/ .veui-dialog-content-head-title {
            display: block;
            width: 100%;
            text-align: center;
            margin-left: 30px;
            color: #000;
            font-size: 20px;
        }

        /deep/ .veui-dialog-content-body {
            width: 660px;
            box-sizing: border-box;
            padding: 2px 0;
            overflow: unset;
        }

        /deep/ .veui-carousel-outside-indicator .veui-carousel-indicator-bottom {
            position: absolute;
            bottom: -32px;
            left: 50%;
            transform: translateX(-50%);
        }

        /deep/ .veui-carousel-outside-indicator .veui-carousel-indicator-item {
            width: 11px;
            height: 11px;
            border-radius: 50%;
            margin: 0 8px;
        }

        /deep/ .veui-carousel {
            box-sizing: border-box;
            width: 100%;
            height: auto;
            padding-bottom: 30px;

            .veui-carousel-viewport-wrap {
                margin: 0 30px;
            }

            .main-content-box {
                height: 100%;
                overflow-y: auto;
            }

            .title {
                font-size: 20px;
                font-weight: 700;
                color: #333;
                text-align: center;
                padding-top: 22px;
                margin-bottom: 4px;
            }

            .time {
                position: relative;
                top: -4px;
                opacity: .65;
                font-size: 14px;
                color: #333;
                text-align: center;
                margin: 0 0 12px;
                line-height: 1;
                padding: 4px 0 0;
            }

            .img-box {
                width: 600px;
                height: 322px;
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
                margin: 0 auto;
                position: relative;
                /* border: 1px solid #F5F5F5;
                border-radius: 24px;
                overflow: hidden; */

                .qrcode-box {
                    position: absolute;
                    right: 40px;
                    top: 40px;
                    background: #ffff;
                    width: 190px;
                    height: 242px;
                    text-align: center;
                    border-radius: 12px;
                    overflow: hidden;
                    border: 1px solid #e3e3e3;

                    img {
                        width: 95%;
                        margin-top: 10px;
                        flex-shrink: 0;
                    }

                    .qrcode-title {
                        color: #848691;
                        font-size: 20px;
                        line-height: 20px;
                    }
                }
            }

            .description {
                width: 100%;
                height: 48px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 14px auto 25px;
                font-size: 16px;
                line-height: 24px;
                color: #000;
                text-align: center;

                .agreement {
                    font-size: 14px;
                    color: #0052cc;
                    cursor: pointer;
                }
            }

            .btn {
                position: relative;
                left: 50%;
                transform: translateX(-50%);
                background: #404eff;
            }
        }

        /deep/ .veui-carousel-control[ui] {
            box-sizing: border-box;
            width: 54px;
            height: 54px;
            border: 1px solid #36f;
            background-color: transparent;
            opacity: .5;
            display: none;
        }

        /deep/ .veui-button[ui~="basic"].veui-disabled {
            opacity: .1;
        }

        /deep/ .veui-icon {
            height: 24px;
            color: #000;
        }

        /deep/ .veui-sr-only {
            display: none;
        }
    }
</style>
